export default __webpack_public_path__ + "static/media/Annons_pdf.4635d0d1.pdf";